/**
 * ClientCalendarV2 Component
 * View-only calendar for client portal
 * Shows events and tasks without create/edit functionality
 */

import React from 'react';
import { ClientCalendarProvider } from './context/ClientCalendarContext';

// Components
import ClientCalendarHeader from './components/ClientCalendarHeader';
import ClientCalendarView from './components/ClientCalendarView';
import ClientEventViewModal from './components/ClientEventViewModal';
import ClientDayEventsPopup from './components/ClientDayEventsPopup';

// Styles - reuse main calendar styles
import '../../calendarv2/styles/calendarv2.scss';
import './styles/client-calendar.scss';

// Inner content component that can access context
const ClientCalendarV2Content = () => {
  return (
    <div className="client-calendar-v2-container">
      {/* Header */}
      <ClientCalendarHeader />

      {/* Main Calendar View */}
      <div className="client-calendar-v2-main card-bg">
        <ClientCalendarView />
      </div>

      {/* Event/Task View Modal */}
      <ClientEventViewModal />

      {/* Day Events Popup */}
      <ClientDayEventsPopup />
    </div>
  );
};

const ClientCalendarV2 = ({ ...props }) => {
  return (
    <ClientCalendarProvider {...props}>
      <ClientCalendarV2Content />
    </ClientCalendarProvider>
  );
};

export default ClientCalendarV2;
